import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchStaticAirtimeAggrByDay } from './actionCreators';

interface InitialState {
  play_secs: number[],
  timeBegin: number | null,
  timeEnd: number | null,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  play_secs: [],
  timeBegin: null,
  timeEnd: null,
  isLoading: false,
  error: '',
};

export const staticAggrAirtimeByDaySlice = createSlice({
  name: 'staticAggrAirtimeByDay',
  initialState,
  reducers: {
    selectTime: (state, action: PayloadAction<{
      timeBegin: number,
      timeEnd: number,
    }>) => {
      state.timeBegin = action.payload.timeBegin;
      state.timeEnd = action.payload.timeEnd;
    },
  },
  extraReducers: {
    [fetchStaticAirtimeAggrByDay.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.play_secs = action.payload;
    },
    [fetchStaticAirtimeAggrByDay.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticAirtimeAggrByDay.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default staticAggrAirtimeByDaySlice.reducer;
